/* Eén afstand voor alle ankers: hoogte van de vaste header + 16px (zelfde als html scroll-padding-top) */
window.ocAnchorOffset = window.ocAnchorOffset || function () {
  var v = parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop);
  if (!isNaN(v) && v > 0) return v;
  var h = document.querySelector('.shopify-section--header');
  return (h ? h.getBoundingClientRect().height : 80) + 16;
};
window.ocScrollTo = window.ocScrollTo || function (target, smooth) {
  if (!target) return;
  var y = function () { return Math.max(0, target.getBoundingClientRect().top + window.pageYOffset - window.ocAnchorOffset()); };
  window.scrollTo({ top: y(), behavior: smooth ? 'smooth' : 'auto' });
  /* Corrigeer als foto's tijdens het scrollen nog laden en de pagina verschuift */
  var moved = false, stop = function () { moved = true; };
  window.addEventListener('touchstart', stop, { passive: true, once: true });
  window.addEventListener('wheel', stop, { passive: true, once: true });
  [700, 1300].forEach(function (t) { setTimeout(function () { if (!moved && Math.abs(target.getBoundingClientRect().top - window.ocAnchorOffset()) > 6) window.scrollTo({ top: y(), behavior: 'auto' }); }, t); });
};
/* ==========================================================================
   OPTICCOLORS — TWIJFELVRIJE PRODUCTPAGINA
   1. Rustig binnenkomen bij scrollen
   2. Voor/na-schuifbalk (met korte hint-animatie) + kleurkiezer die de voor/na wisselt
   3. Kleurtest
   4. Vaste bestelbalk
   ========================================================================== */
(function () {
  if (window.__ocTwijfelvrij) return;
  window.__ocTwijfelvrij = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = window.Shopify && window.Shopify.designMode;

  /* ---------- 1. Binnenkomen bij scrollen ---------- */
  var revealObserver = ('IntersectionObserver' in window && !designMode && !reduceMotion)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 })
    : null;

  function initReveal(root) {
    root.querySelectorAll('[data-oc-reveal]:not(.is-in)').forEach(function (el) {
      if (revealObserver) revealObserver.observe(el);
      else el.classList.add('is-in');
    });
  }

  /* ---------- 2. Voor/na ---------- */
  function setPos(ba, value) { ba.style.setProperty('--pos', value + '%'); }

  /* Hint-animatie: de lijn schuift helemaal over BEIDE ogen, zodat je echt het verschil ziet.
     50% → 86% (beide ogen zonder lens) → pauze → 14% (beide ogen mét lens) → pauze → 50%. */
  var HINT_STEPS = [[50, 0], [86, 1100], [86, 1700], [14, 3500], [14, 4100], [50, 4900]];
  function ease(p) { return p < .5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2; }
  function hint(ba) {
    if (reduceMotion || ba.dataset.ocHinted) return;
    ba.dataset.ocHinted = '1';
    var start = null;
    var end = HINT_STEPS[HINT_STEPS.length - 1][1];
    function frame(t) {
      if (ba.dataset.ocTouched) return;
      if (!start) start = t;
      var el = t - start;
      var v = 50;
      for (var i = 1; i < HINT_STEPS.length; i++) {
        var a = HINT_STEPS[i - 1], b = HINT_STEPS[i];
        if (el <= b[1]) { var p = (el - a[1]) / Math.max(1, b[1] - a[1]); v = a[0] + (b[0] - a[0]) * ease(Math.min(1, Math.max(0, p))); break; }
      }
      setPos(ba, v);
      if (el < end) requestAnimationFrame(frame);
      else setPos(ba, 50);
    }
    requestAnimationFrame(frame);
  }

  var hintObserver = ('IntersectionObserver' in window)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { hint(entry.target); hintObserver.unobserve(entry.target); }
        });
      }, { threshold: 0.5 })
    : null;

  function initBeforeAfter(root) {
    root.querySelectorAll('[data-oc-ba]:not([data-oc-ba-ready])').forEach(function (ba) {
      ba.setAttribute('data-oc-ba-ready', '');
      var range = ba.querySelector('input[type="range"]');
      if (!range) return;
      range.addEventListener('input', function () {
        ba.dataset.ocTouched = '1';
        setPos(ba, range.value);
      });
      if (hintObserver && ba.offsetParent !== null) hintObserver.observe(ba);
    });
  }

  /* ---------- 2b. Kleurkiezer onder de voor/na: tik op een kleur, de voor/na wisselt mee ---------- */
  function preload(url, cb) {
    var img = new Image();
    img.onload = img.onerror = function () { if (cb) cb(); };
    img.src = url;
  }

  function initPicker(root) {
    root.querySelectorAll('[data-oc-picker]:not([data-oc-picker-ready])').forEach(function (pk) {
      pk.setAttribute('data-oc-picker-ready', '');
      var ba = pk.querySelector('[data-oc-ba]');
      if (!ba) return;
      var afterImg = ba.querySelector(':scope > img');
      var beforeImg = ba.querySelector('.oc-ba__before img');
      var label = ba.querySelector('.oc-ba__label--after');
      var view = pk.querySelector('[data-oc-picker-view]');
      var token = 0;

      function warm(sw) {
        if (!sw || sw.dataset.ocWarm) return;
        sw.dataset.ocWarm = '1';
        preload(sw.dataset.after); preload(sw.dataset.before);
      }
      pk.addEventListener('pointerover', function (e) { warm(e.target.closest('.oc-tv-swatch[data-before]')); });
      pk.addEventListener('touchstart', function (e) { warm(e.target.closest('.oc-tv-swatch[data-before]')); }, { passive: true });

      pk.addEventListener('click', function (e) {
        var sw = e.target.closest('.oc-tv-swatch[data-before]');
        if (!sw || sw.getAttribute('aria-pressed') === 'true') return;
        pk.querySelectorAll('.oc-tv-swatch[data-before]').forEach(function (b) { b.setAttribute('aria-pressed', b === sw ? 'true' : 'false'); });
        if (view) { view.href = sw.dataset.url; view.textContent = sw.dataset.viewLabel; }
        var mine = ++token;
        var left = 2;
        ba.classList.add('is-swapping');
        function ready() {
          if (--left > 0 || mine !== token) return;
          [afterImg, beforeImg].forEach(function (img) { if (img) { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.loading = 'eager'; } });
          if (afterImg) afterImg.src = sw.dataset.after;
          if (beforeImg) beforeImg.src = sw.dataset.before;
          if (sw.dataset.ratio) ba.style.setProperty('--oc-ratio', sw.dataset.ratio);
          if (label) label.textContent = sw.dataset.afterLabel;
          ba.classList.remove('is-swapping');
          delete ba.dataset.ocHinted; delete ba.dataset.ocTouched;
          var range = ba.querySelector('input[type="range"]');
          if (range) range.value = 50;
          setPos(ba, 50);
          hint(ba);
        }
        preload(sw.dataset.after, ready);
        preload(sw.dataset.before, ready);
      });
    });
  }

  /* ---------- 3. Kleurtest ----------
     Per kleurrichting de lenzen op volgorde van natuurlijk → opvallend. Afhankelijk van je eigen oogkleur:
     - Altijd 3 standen: natuurlijk → zichtbaar → opvallend, elke stand is een andere lens.
     - Zie OC_STOPS voor de keuzes per oogkleur (op basis van klanttevredenheid).
     De schuifbalk start op de bestseller van de richting (bestseller wint bij twijfel). */
  var OC_BEST = ['meli', 'hazel', 'ocean', 'true-blue', 'ice', 'crystal', 'allure', 'sky', 'topaz', 'aqua', 'verde', 'emerald'];
  function OC_LIGHT_EYES(eye) { return eye === 'green' || eye === 'blue' || eye === 'gray'; }
  /* Per richting alleen lenzen van die kleur (keuze eigenaar, okt. 2026). Altijd 3 standen;
     richtingen met minder lenzen herhalen de opvallendste. */
  function OC_STOPS(eye, dir) {
    switch (dir) {
      case 'green': return ['meli', 'allure', 'verde'];
      case 'brown': return ['hazel', 'hazel', 'hazel'];
      case 'blue': return ['ocean', 'true-blue', 'sky'];
      case 'turq': return ['aqua', 'topaz', 'topaz'];
      default: return ['crystal', 'ice', 'ice'];
    }
  }
  function OC_QUIZ_PICK(eye, dir, lvl) {
    var stops = OC_STOPS(eye, dir);
    var i = Math.max(1, Math.min(stops.length, Number(lvl) || 1)) - 1;
    return stops[i];
  }
  /* Startstand: de bestseller van de 3 standen (bij honing: Hazel) – zo wordt de bestseller het vaakst geadviseerd */
  function OC_DEFAULT_STOP(stops, dir) {
    if (dir === 'brown') return 1;
    var best = 0;
    stops.forEach(function (h, i) { if (OC_BEST.indexOf(h) < OC_BEST.indexOf(stops[best])) best = i; });
    return best + 1;
  }
  /* Ook aanbevolen: alleen dezelfde richting, dichtstbijzijnde eerst, max. 2. Bij bruin op lichte ogen: Meli als zachter alternatief. */
  function OC_QUIZ_ALTS(eye, dir, pick) {
    var fam = OC_STOPS(eye, dir).filter(function (h, k, a) { return a.indexOf(h) === k; });
    var i = fam.indexOf(pick);
    var alts = fam.filter(function (h) { return h !== pick; }).sort(function (x, y) { return Math.abs(fam.indexOf(x) - i) - Math.abs(fam.indexOf(y) - i) || fam.indexOf(x) - fam.indexOf(y); });
    if (dir === 'brown' && OC_LIGHT_EYES(eye)) alts = ['meli'];
    /* Bruine ogen + natuurlijk groen of grijs: Hazel (bestseller, 4,8★, "zo natuurlijk dat niemand het ziet") als tweede alternatief */
    if ((dir === 'green' || dir === 'light') && !OC_LIGHT_EYES(eye) && i === 0) alts = [alts[0], 'hazel'];
    return alts.slice(0, 2);
  }

  /* Kleuren van de lenzen, gemeten in de close-ups van onze productfoto's (op bruine ogen), gecorrigeerd voor de witbalans.
     cov = hoeveel de lens je eigen kleur afdekt (uit foto's + klantreviews). Je eigen oogkleur schijnt door de rest heen. */
  var OC_LENS_PAL = {"meli":{"cov":0.66,"in":"#8a7b50","main":"#9b9b70","hi":"#c6c69c","out":"#6c7052"},"hazel":{"cov":0.8,"in":"#6a4a36","main":"#8e6d58","hi":"#b8957e","out":"#5a4134"},"ocean":{"cov":0.8,"in":"#63665f","main":"#959b8d","hi":"#c6cebd","out":"#5c635c"},"true-blue":{"cov":0.76,"in":"#5f617e","main":"#7684a8","hi":"#a0acd2","out":"#42517b"},"ice":{"cov":0.84,"in":"#6f636f","main":"#948899","hi":"#bbb4c7","out":"#5e5867"},"crystal":{"cov":0.82,"in":"#837c6d","main":"#979284","hi":"#bcb5a8","out":"#6b6961"},"allure":{"cov":0.78,"in":"#6f6957","main":"#837e66","hi":"#a5a081","out":"#58553d"},"sky":{"cov":0.82,"in":"#4f6b98","main":"#5e83ba","hi":"#93b3de","out":"#304f86"},"topaz":{"cov":0.86,"in":"#5f6f6d","main":"#729194","hi":"#94bac2","out":"#41636c"},"aqua":{"cov":0.82,"in":"#49666b","main":"#50767b","hi":"#6b9daa","out":"#35525a"},"verde":{"cov":0.72,"in":"#58572e","main":"#5d6446","hi":"#7b9895","out":"#3d4129"},"emerald":{"cov":0.84,"in":"#5b6a55","main":"#6a8278","hi":"#90aba0","out":"#3f5048"}};
  /* Eigen oogkleur (vraag 1) */
  var OC_EYE_BASE = {
    dark: { in: '#4a2e1c', mid: '#2e1a10', out: '#140a06', hi: '#5a3a24' },
    brown: { in: '#8a5a2c', mid: '#6b4423', out: '#2e1a0e', hi: '#a0703c' },
    green: { in: '#8a7a3c', mid: '#6f8150', out: '#2f3a22', hi: '#9fb07a' },
    gray: { in: '#8e9294', mid: '#8c979e', out: '#3e474e', hi: '#b9c2c8' },
    blue: { in: '#8aa2b8', mid: '#6f93bd', out: '#2d4a6c', hi: '#a9c2dc' }
  };

  /* Geïllustreerd, geanimeerd oog */
  var NS = 'http://www.w3.org/2000/svg';
  function rnd(seed) { return function () { seed = (seed * 9301 + 49297) % 233280; return seed / 233280; }; }
  /* Iris: middelpunt en straal binnen viewBox 0 0 300 170 */
  var CX = 152, CY = 92, R = 54;

  function fibers(n, r0, r1, seed, w0, w1) {
    var r = rnd(seed), d = '';
    for (var i = 0; i < n; i++) {
      var a = (i / n) * Math.PI * 2 + (r() - .5) * .05;
      var s = r0 + r() * (r1 - r0) * .25, e = r1 - r() * (r1 - r0) * .35;
      var bend = (r() - .5) * .12;
      var x1 = CX + Math.cos(a) * s, y1 = CY + Math.sin(a) * s;
      var xm = CX + Math.cos(a + bend) * (s + e) / 2, ym = CY + Math.sin(a + bend) * (s + e) / 2;
      var x2 = CX + Math.cos(a) * e, y2 = CY + Math.sin(a) * e;
      d += 'M' + x1.toFixed(1) + ' ' + y1.toFixed(1) + 'Q' + xm.toFixed(1) + ' ' + ym.toFixed(1) + ' ' + x2.toFixed(1) + ' ' + y2.toFixed(1);
    }
    return d;
  }
  function dots(n, r0, r1, seed) {
    var r = rnd(seed), d = '';
    for (var i = 0; i < n; i++) {
      var a = r() * Math.PI * 2, q = Math.sqrt(r0 * r0 + r() * (r1 * r1 - r0 * r0));
      var x = CX + Math.cos(a) * q, y = CY + Math.sin(a) * q, s = .55 + r() * .9;
      d += 'M' + (x - s).toFixed(1) + ' ' + y.toFixed(1) + 'a' + s.toFixed(2) + ' ' + s.toFixed(2) + ' 0 1 0 ' + (2 * s).toFixed(2) + ' 0a' + s.toFixed(2) + ' ' + s.toFixed(2) + ' 0 1 0 ' + (-2 * s).toFixed(2) + ' 0';
    }
    return d;
  }

  function lensGroup(id, k) {
    return '<g class="oce-lens" data-k="' + k + '" style="opacity:0">' +
      '<circle cx="' + CX + '" cy="' + CY + '" r="' + R + '" fill="url(#oce-lg-' + id + '-' + k + ')"/>' +
      '<path d="' + fibers(150, R * .36, R * .97, 11 + k * 7) + '" fill="none" style="stroke:var(--l' + k + '-hi)" stroke-width=".9" stroke-linecap="round" opacity=".75"/>' +
      '<path d="' + fibers(90, R * .4, R * .9, 51 + k * 5) + '" fill="none" style="stroke:var(--l' + k + '-out)" stroke-width=".7" stroke-linecap="round" opacity=".45"/>' +
      '<path d="' + dots(260, R * .42, R * .95, 91 + k * 3) + '" style="fill:var(--l' + k + '-hi)" opacity=".55"/>' +
      '<circle cx="' + CX + '" cy="' + CY + '" r="' + (R * .955) + '" fill="none" style="stroke:var(--l' + k + '-out)" stroke-width="' + (R * .1).toFixed(1) + '" opacity=".9"/>' +
      '<circle cx="' + CX + '" cy="' + CY + '" r="' + (R * .41) + '" fill="none" style="stroke:var(--l' + k + '-in)" stroke-width="' + (R * .09).toFixed(1) + '" stroke-dasharray="1.6 1.2" opacity=".7"/>' +
      '</g>';
  }

  function svg(id) {
        var eyeShape = 'M36 98 C 70 50, 118 34, 164 35 C 208 36, 246 56, 270 86 C 240 122, 196 140, 150 140 C 104 140, 64 128, 36 98 Z';
    var lg = function (k) {
      return '<radialGradient id="oce-lg-' + id + '-' + k + '" cx="' + CX + '" cy="' + CY + '" r="' + R + '" gradientUnits="userSpaceOnUse">' +
        '<stop offset=".30" style="stop-color:var(--l' + k + '-in)" stop-opacity="0"/>' +
        '<stop offset=".40" style="stop-color:var(--l' + k + '-in)" stop-opacity=".9"/>' +
        '<stop offset=".62" style="stop-color:var(--l' + k + '-main)"/>' +
        '<stop offset=".86" style="stop-color:var(--l' + k + '-main)"/>' +
        '<stop offset="1" style="stop-color:var(--l' + k + '-out)"/></radialGradient>';
    };
    return '<svg class="oce" viewBox="0 0 300 170" aria-hidden="true">' +
      '<defs>' +
      '<clipPath id="oce-eye-' + id + '"><path d="' + eyeShape + '"/></clipPath>' +
      '<clipPath id="oce-iris-' + id + '"><circle cx="' + CX + '" cy="' + CY + '" r="' + R + '"/></clipPath>' +
      '<radialGradient id="oce-skin-' + id + '" cx="50%" cy="54%" r="60%"><stop offset="0" stop-color="#f3e3d8"/><stop offset=".6" stop-color="#f7ece5" stop-opacity=".6"/><stop offset="1" stop-color="#fff" stop-opacity="0"/></radialGradient>' +
      '<radialGradient id="oce-scl-' + id + '" cx="' + CX + '" cy="' + (CY + 6) + '" r="130" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#ffffff"/><stop offset=".45" stop-color="#fbfcfd"/><stop offset=".8" stop-color="#e9eef3"/><stop offset="1" stop-color="#d8dfe7"/></radialGradient>' +
      '<radialGradient id="oce-base-' + id + '" cx="' + CX + '" cy="' + CY + '" r="' + R + '" gradientUnits="userSpaceOnUse"><stop offset=".28" style="stop-color:var(--b-in)"/><stop offset=".55" style="stop-color:var(--b-mid)"/><stop offset=".88" style="stop-color:var(--b-mid)"/><stop offset="1" style="stop-color:var(--b-out)"/></radialGradient>' +
      lg(0) + lg(1) +
      '<radialGradient id="oce-depth-' + id + '" cx="' + CX + '" cy="' + CY + '" r="' + R + '" gradientUnits="userSpaceOnUse"><stop offset=".55" stop-color="#000" stop-opacity="0"/><stop offset=".9" stop-color="#000" stop-opacity=".12"/><stop offset="1" stop-color="#000" stop-opacity=".38"/></radialGradient>' +
      '<linearGradient id="oce-lidsh-' + id + '" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#2a1d16" stop-opacity=".42"/><stop offset=".3" stop-color="#2a1d16" stop-opacity=".1"/><stop offset=".45" stop-color="#2a1d16" stop-opacity="0"/></linearGradient>' +
      '<linearGradient id="oce-sheen-' + id + '" x1="0" y1="0" x2="1" y2="0"><stop offset="0" stop-color="#fff" stop-opacity="0"/><stop offset=".5" stop-color="#fff" stop-opacity=".45"/><stop offset="1" stop-color="#fff" stop-opacity="0"/></linearGradient>' +
      '</defs>' +
      '<ellipse cx="152" cy="92" rx="140" ry="76" fill="url(#oce-skin-' + id + ')"/>' +
      '<path class="oce-crease" d="M54 70 C 92 26, 196 14, 258 54" fill="none" stroke="#b08b76" stroke-opacity=".22" stroke-width="2.4" stroke-linecap="round"/>' +
      '<g clip-path="url(#oce-eye-' + id + ')">' +
        '<rect width="300" height="170" fill="url(#oce-scl-' + id + ')"/>' +
        '<path d="M36 98 C 41 90, 49 89, 56 94 C 51 103, 42 104, 36 98 Z" fill="#e9a99f" opacity=".75"/>' +
        '<g class="oce-look">' +
          '<g clip-path="url(#oce-iris-' + id + ')">' +
            '<circle cx="' + CX + '" cy="' + CY + '" r="' + R + '" fill="url(#oce-base-' + id + ')"/>' +
            '<path d="' + fibers(120, R * .3, R * .95, 7) + '" fill="none" style="stroke:var(--b-hi)" stroke-width=".8" stroke-linecap="round" opacity=".6"/>' +
            '<g class="oce-lenses">' + lensGroup(id, 0) + lensGroup(id, 1) + '</g>' +
            '<circle cx="' + CX + '" cy="' + CY + '" r="' + R + '" fill="url(#oce-depth-' + id + ')"/>' +
            '<rect class="oce-sheen" x="' + (CX - 70) + '" y="' + (CY - 60) + '" width="36" height="120" fill="url(#oce-sheen-' + id + ')" transform="rotate(20 ' + CX + ' ' + CY + ')"/>' +
          '</g>' +
          '<circle cx="' + CX + '" cy="' + CY + '" r="' + (R - .6) + '" fill="none" stroke="#0e0a08" stroke-opacity=".35" stroke-width="1.4"/>' +
          '<circle class="oce-pupil" cx="' + CX + '" cy="' + CY + '" r="' + (R * .31).toFixed(1) + '" fill="#07070a"/>' +
          '<path d="M' + (CX + 13) + ' ' + (CY - 27) + ' q 11 -2 16 9 q -9 -4 -16 -9 z" fill="#fff" opacity=".95"/>' +
          '<circle cx="' + (CX - 15) + '" cy="' + (CY + 17) + '" r="2.2" fill="#fff" opacity=".45"/>' +
        '</g>' +
        '<rect width="300" height="170" fill="url(#oce-lidsh-' + id + ')"/>' +
        '<path d="M38 99 C 66 128, 106 139, 150 139 C 196 139, 240 122, 269 87" fill="none" stroke="#ecbcb0" stroke-opacity=".85" stroke-width="3.2"/>' +
        '<rect class="oce-blink" x="0" y="-170" width="300" height="170" fill="#f1e2d8"/>' +
      '</g>' +
      '<path class="oce-lid" d="M33 99 C 68 48, 118 31, 164 32 C 210 33, 248 54, 273 86 C 276 82, 276 78, 273 75 C 246 46, 210 27, 164 26 C 116 25, 66 44, 33 99 Z" fill="#1d1410"/>' +
      '<path d="M272 80 q 8 -3 13 -12" fill="none" stroke="#1d1410" stroke-width="2.6" stroke-linecap="round"/>' +
      '<path d="M38 101 C 66 132, 106 144, 150 144 C 198 144, 242 126, 271 89" fill="none" stroke="#8f6a57" stroke-opacity=".32" stroke-width="1.5" stroke-linecap="round"/>' +
      '</svg>';
  }

  function setVars(el, prefix, pal) { for (var k in pal) if (k !== 'cov') el.style.setProperty(prefix + k, pal[k]); }

  /* Eén oog-instantie. base = {in, mid, out, hi}; lens = {in, main, hi, out, cov} */
  function Eye(host, id) {
    host.innerHTML = svg(id);
    this.root = host.querySelector('svg');
    this.slot = 0; this.cur = null;
    this.groups = this.root.querySelectorAll('.oce-lens');
  }
  Eye.prototype.base = function (b) { var r = this.root; r.style.setProperty('--b-in', b.in); r.style.setProperty('--b-mid', b.mid); r.style.setProperty('--b-out', b.out); r.style.setProperty('--b-hi', b.hi); };
  Eye.prototype.clear = function () {
    this.cur = null;
    Array.prototype.forEach.call(this.groups, function (g) { g.style.transition = 'none'; g.style.opacity = 0; });
  };
  Eye.prototype.lens = function (key, pal, animate) {
    if (key === this.cur) return;
    this.cur = key;
    var s = this.slot = 1 - this.slot, inG = this.groups[s], outG = this.groups[1 - s];
    setVars(this.root, '--l' + s + '-', pal);
    inG.style.transition = 'none';
    inG.style.opacity = 0;
    inG.style.transform = animate ? 'rotate(-28deg) scale(1.06)' : 'none';
    void inG.getBoundingClientRect();
    inG.style.transition = animate ? 'opacity .55s ease, transform .9s cubic-bezier(.2,.8,.2,1)' : 'none';
    inG.style.opacity = pal.cov; inG.style.transform = 'none';
    outG.style.transition = animate ? 'opacity .45s ease .1s' : 'none';
    outG.style.opacity = 0;
    if (animate) { this.root.classList.remove('is-pop'); void this.root.getBoundingClientRect(); this.root.classList.add('is-pop'); }
  };

  function initQuiz(root) {
    root.querySelectorAll('[data-oc-quiz]:not([data-oc-quiz-ready])').forEach(function (quiz, qi) {
      quiz.setAttribute('data-oc-quiz-ready', '');
      var steps = Array.prototype.slice.call(quiz.querySelectorAll('[data-oc-step]'));
      var result = quiz.querySelector('[data-oc-result]');
      var pool = quiz.querySelector('[data-oc-alt-pool]');
      var answers = {};
      var current = 1;

      function go(n, scroll) {
        current = Math.max(1, n);
        var done = current > steps.length;
        steps.forEach(function (s) { s.hidden = Number(s.dataset.ocStep) !== current; });
        result.hidden = !done;
        if (done) showResult();
        if (scroll !== false) {
          var top = quiz.getBoundingClientRect().top + window.pageYOffset - window.ocAnchorOffset();
          if (Math.abs(window.pageYOffset - top) > 120) window.scrollTo({ top: top, behavior: reduceMotion ? 'auto' : 'smooth' });
        }
      }

      function panelFor(handle) { return quiz.querySelector('[data-oc-panel="' + handle + '"]'); }
      function isAvailable(handle) { var p = panelFor(handle); return p && p.dataset.available !== 'false'; }
      function titleFor(handle) { var p = panelFor(handle); return p ? p.dataset.ocColour : handle; }

      function showResult() {
        var eye = answers.eye, dir = answers.dir || 'green', lvl = answers.lvl || 1;
        var pick = OC_QUIZ_PICK(eye, dir, lvl);
        /* Uitverkocht of niet gevonden? Dan de dichtstbijzijnde kleur uit dezelfde richting. */
        if (!isAvailable(pick)) {
          var fam = OC_STOPS(eye, dir);
          var i = fam.indexOf(pick);
          var order = fam.slice().sort(function (x, y) { return Math.abs(fam.indexOf(x) - i) - Math.abs(fam.indexOf(y) - i); });
          for (var k = 0; k < order.length; k++) { if (isAvailable(order[k])) { pick = order[k]; break; } }
        }
        var shown = null;
        quiz.querySelectorAll('[data-oc-panel]').forEach(function (panel) {
          var match = panel.dataset.ocPanel === pick;
          panel.hidden = !match;
          if (match) shown = panel;
        });
        if (!shown) return;
        var lightEyes = OC_LIGHT_EYES(eye);
        var tipKey = (dir === 'brown' && lightEyes) ? 'brownlight' : (lightEyes ? 'light' : 'dark');
        shown.querySelectorAll('[data-oc-tip]').forEach(function (tip) { tip.hidden = tip.dataset.ocTip !== tipKey; });

        var box = shown.querySelector('[data-oc-alts]');
        var row = shown.querySelector('[data-oc-alts-row]');
        if (box && row && pool) {
          row.innerHTML = '';
          OC_QUIZ_ALTS(eye, dir, pick).forEach(function (h) {
            var card = pool.querySelector('[data-oc-alt="' + h + '"]');
            if (card && card.dataset.available !== 'false') row.appendChild(card.cloneNode(true));
          });
          box.hidden = row.children.length === 0;
        }
        initBeforeAfter(shown);
        shown.querySelectorAll('[data-oc-ba]').forEach(function (ba) { delete ba.dataset.ocHinted; hint(ba); });
        if (window.dataLayer) window.dataLayer.push({ event: 'oc_kleurtest_result', oc_colour: shown.dataset.ocColour, oc_answers: [eye, dir, lvl].join('_') });
      }

      /* Schuifbalk + oog */
      var IRIS = { green: '#7d9a5a', brown: '#b9823f', blue: '#4a86d0', turq: '#2fb0b8', light: '#aeb9c0' };
      var slide = quiz.querySelector('[data-oc-slide]');
      var range = slide && slide.querySelector('[data-oc-slide-range]');
      var eyeHost = slide && slide.querySelector('[data-oc-eye]');
      var eyeView = eyeHost ? new Eye(eyeHost, 'q' + qi) : null;
      var stops = ['meli', 'allure', 'emerald'];
      /* Label per stand: bij 2 standen "natuurlijk" en "opvallend" */
      function labelLevel(v) { return stops.length === 3 ? v : (v === 1 ? 1 : 3); }

      function setupStops() {
        stops = OC_STOPS(answers.eye, answers.dir || 'green');
        if (range) { range.min = 1; range.max = Math.max(2, stops.length); }
        if (slide) slide.classList.toggle('oc-qslide--two', stops.length === 2);
        slide && slide.querySelectorAll('[data-oc-tick]').forEach(function (b) {
          var n = Number(b.dataset.ocTick);
          if (stops.length === 2) {
            b.hidden = n === 2;
            b.dataset.ocStop = n === 1 ? 1 : 2;
          } else { b.hidden = false; b.dataset.ocStop = n; }
        });
        if (eyeView) { eyeView.base(OC_EYE_BASE[answers.eye] || OC_EYE_BASE.brown); eyeView.clear(); }
        /* Eerst je eigen oog, daarna draait de lens erin */
        var start = OC_DEFAULT_STOP(stops, answers.dir);
        if (range) { range.value = start; }
        setTimeout(function () { setLevel(start, true); }, reduceMotion ? 0 : 650);
      }

      function setLevel(v, bump) {
        if (!slide) return;
        var max = stops.length;
        v = Math.max(1, Math.min(max, Number(v) || 1));
        if (range) { range.value = v; range.style.setProperty('--fill', (max > 1 ? (v - 1) / (max - 1) * 100 : 0) + '%'); }
        var L = labelLevel(v);
        var t = slide.querySelector('[data-oc-slide-title]'), sub = slide.querySelector('[data-oc-slide-sub]');
        if (t) t.textContent = slide.getAttribute('data-t' + L);
        if (sub) sub.textContent = slide.getAttribute('data-s' + L);
        slide.querySelectorAll('[data-oc-tick]').forEach(function (b) { b.setAttribute('aria-pressed', Number(b.dataset.ocStop) === v ? 'true' : 'false'); });
        var h = stops[v - 1];
        if (eyeView && OC_LENS_PAL[h]) eyeView.lens(h, OC_LENS_PAL[h], bump && !reduceMotion);
        if (bump && navigator.vibrate) { try { navigator.vibrate(8); } catch (e) {} }
      }

      if (range) range.addEventListener('input', function () { setLevel(range.value, true); });
      if (eyeView) eyeView.base(OC_EYE_BASE.brown);

      function confetti() {
        var box = quiz.querySelector('[data-oc-confetti]');
        if (!box || reduceMotion) return;
        box.innerHTML = '';
        var colors = [IRIS[answers.dir] || '#3d9be9', '#3d9be9', '#ffc83d', '#e32c2b', '#22a447', '#b4c7d2'];
        for (var i = 0; i < 34; i++) {
          var el = document.createElement('i');
          var ang = Math.random() * Math.PI * 2, dist = 90 + Math.random() * 140;
          el.style.setProperty('--x', Math.round(Math.cos(ang) * dist) + 'px');
          el.style.setProperty('--y', Math.round(Math.sin(ang) * dist * .7 + 60) + 'px');
          el.style.setProperty('--r', Math.round(Math.random() * 720 - 360) + 'deg');
          el.style.setProperty('--d', Math.round(Math.random() * 120) + 'ms');
          el.style.background = colors[i % colors.length];
          box.appendChild(el);
        }
        setTimeout(function () { box.innerHTML = ''; }, 1700);
      }

      quiz.addEventListener('click', function (event) {
        var answer = event.target.closest('[data-oc-answer]');
        if (answer) {
          if (quiz.dataset.ocBusy) return;
          quiz.dataset.ocBusy = '1';
          answers[answer.dataset.ocAnswer] = answer.dataset.value;
          var skip = false;
          /* Bruine ogen: 'Honing of bruin' (Hazel) bovenaan in vraag 2 – het meest natuurlijke resultaat op bruine ogen */
          if (answer.dataset.ocAnswer === 'eye') {
            var list = quiz.querySelector('[data-oc-step="2"] .oc-tv-quiz__options');
            var honey = list && list.querySelector('[data-value="brown"]');
            var green = list && list.querySelector('[data-value="green"]');
            if (honey && green) {
              if (OC_LIGHT_EYES(answer.dataset.value)) list.insertBefore(green, list.firstElementChild);
              else list.insertBefore(honey, list.firstElementChild);
            }
          }
          if (answer.dataset.ocAnswer === 'dir') {
            quiz.style.setProperty('--oc-iris', IRIS[answer.dataset.value] || '#3d9be9');
            setupStops();
            /* Maar één lens in deze richting (Hazel)? Dan meteen naar de uitslag. */
            skip = stops.length === 1;
            answers.lvl = skip ? 1 : answers.lvl;
          }
          answer.classList.add('is-picked');
          if (navigator.vibrate) { try { navigator.vibrate(10); } catch (e) {} }
          setTimeout(function () {
            answer.classList.remove('is-picked');
            delete quiz.dataset.ocBusy;
            answers.skipped = skip;
            go(current + (skip ? 2 : 1));
            if (skip) setTimeout(confetti, 120);
          }, reduceMotion ? 0 : 280);
          return;
        }
        var tick = event.target.closest('[data-oc-tick]');
        if (tick) { setLevel(tick.dataset.ocStop || tick.dataset.ocTick, true); return; }
        if (event.target.closest('[data-oc-slide-go]')) {
          answers.lvl = range ? Number(range.value) : 1;
          go(current + 1);
          setTimeout(confetti, 120);
          return;
        }
        if (event.target.closest('[data-oc-back]')) go(current - (current > steps.length && answers.skipped ? 2 : 1));
        if (event.target.closest('[data-oc-restart]')) { answers = {}; go(1); }
      });

      go(1, false);
    });
  }

  /* ---------- 4. Vaste bestelbalk ---------- */
  function initSticky() {
    var bar = document.querySelector('[data-oc-sticky]');
    var hero = document.querySelector('[data-oc-hero]');
    var buy = document.getElementById('oc-buy');
    if (!bar || !('IntersectionObserver' in window)) return;
    var heroVisible = true;
    var buyVisible = false;

    function update() {
      var on = !heroVisible && !buyVisible;
      bar.classList.toggle('is-visible', on);
      document.documentElement.classList.toggle('oc-sticky-on', on);
    }

    if (hero) new IntersectionObserver(function (e) { heroVisible = e[0].isIntersecting; update(); }).observe(hero);
    else heroVisible = false;

    var seen = new Map();
    var watch = [];
    if (buy) watch.push(buy.closest('.shopify-section') || buy);
    var grid = document.getElementById('oc-producten');
    if (grid) watch.push(grid);
    if (watch.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { seen.set(en.target, en.isIntersecting); });
        buyVisible = false;
        seen.forEach(function (v) { if (v) buyVisible = true; });
        update();
      }, { rootMargin: '0px 0px -20% 0px' });
      watch.forEach(function (el) { io.observe(el); });
    }
  }

  /* ---------- Soepel naar ankers scrollen (rekening houden met vaste header) ---------- */
  document.addEventListener('click', function (event) {
    var link = event.target.closest('.oc-tv a[href^="#oc-"], [data-oc-sticky] a[href^="#oc-"]');
    if (!link) return;
    var target = document.getElementById(link.getAttribute('href').slice(1));
    if (!target) return;
    event.preventDefault();
    window.ocScrollTo(target, !reduceMotion);
    if (history.replaceState) history.replaceState(null, '', '#' + target.id);
  });

  /* Uitleg bij twijfels: op desktop altijd open, op mobiel uitklapbaar */
  var desktop = window.matchMedia('(min-width: 800px)');
  function syncMore(root) {
    (root || document).querySelectorAll('[data-oc-more]').forEach(function (d) { if (desktop.matches) d.open = true; });
  }
  if (desktop.addEventListener) desktop.addEventListener('change', function () { syncMore(document); });

  /* Cijfers in de highlights tellen op zodra ze in beeld komen (14u, 40%, −8,00) */
  var countObserver = ('IntersectionObserver' in window && !reduceMotion)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          countObserver.unobserve(entry.target);
          var el = entry.target, txt = el.textContent, m = txt.match(/\d+/);
          if (!m) return;
          var end = parseInt(m[0], 10), pre = txt.slice(0, m.index), post = txt.slice(m.index + m[0].length), start = null;
          function frame(t) {
            if (!start) start = t;
            var p = Math.min((t - start) / 900, 1), v = Math.round(end * (1 - Math.pow(1 - p, 3)));
            el.textContent = pre + v + post;
            if (p < 1) requestAnimationFrame(frame); else el.textContent = txt;
          }
          requestAnimationFrame(frame);
        });
      }, { threshold: 0.6 })
    : null;
  function initCount(root) {
    if (!countObserver) return;
    root.querySelectorAll('.oc-hl__stat:not([data-oc-counted])').forEach(function (el) { el.setAttribute('data-oc-counted', ''); countObserver.observe(el); });
  }

  function initAll(root) {
    initCount(root);
    syncMore(root);
    initReveal(root);
    initBeforeAfter(root);
    initPicker(root);
    initQuiz(root);
  }

  /* Direct naar een onderdeel bij een link als ...?view=twijfelvrij#oc-kleurtest (corrigeert voor vaste header en laden van foto's) */
  function jumpToHash() {
    var id = (location.hash || '').slice(1);
    if (!/^oc-/.test(id)) return;
    var target = document.getElementById(id);
    if (!target) return;
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    var userMoved = false;
    function stop() { userMoved = true; }
    window.addEventListener('wheel', stop, { passive: true, once: true });
    window.addEventListener('touchstart', stop, { passive: true, once: true });
    function go() {
      if (userMoved) return;
      window.scrollTo(0, Math.max(0, target.getBoundingClientRect().top + window.pageYOffset - window.ocAnchorOffset()));
    }
    go();
    [150, 500, 1200, 2200].forEach(function (t) { setTimeout(go, t); });
    window.addEventListener('load', function () { setTimeout(go, 50); });
  }

  function boot() {
    initAll(document);
    initSticky();
    jumpToHash();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
